import * as React from "react";
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle, DialogClose, Button, Input, Text } from "@/src/components";
import { ComponentPage } from "@/components/docs/component-page";

export default function DocsComponentsModal() {
  const code = `import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle, DialogClose } from "@/src/components";
import { Button } from "@/src/components";
import { Input } from "@/src/components";
import { Text } from "@/src/components";
import * as React from "react";

export function ModalDemo() {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)}>Open Modal</Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Invite teammates</DialogTitle>
          </DialogHeader>
          <div className="space-y-2">
            <Text className="text-sm text-muted-foreground">
              Add members to your project to collaborate.
            </Text>
            <Input placeholder="Email" />
          </div>
          <DialogFooter>
            <DialogClose asChild>
              <Button variant="outline">Cancel</Button>
            </DialogClose>
            <Button>Send Invites</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}`;

  const installCommand = `npm install`;

  return (
    <ComponentPage
      title="Modal"
      description="Dialog-based modal component for focused interactions."
      preview={
        <Dialog>
          <Button variant="outline">Open Modal</Button>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Invite teammates</DialogTitle>
            </DialogHeader>
            <div className="space-y-2">
              <Text className="text-sm text-muted-foreground">
                Add members to your project to collaborate.
              </Text>
              <Input placeholder="Email" />
            </div>
            <DialogFooter>
              <Button variant="outline">Cancel</Button>
              <Button>Send Invites</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      }
      code={code}
      installCommand={installCommand}
      apiReference={{
        name: "DialogProps",
        props: [
          {
            name: "open",
            type: "boolean",
            description: "Controlled open state.",
          },
          {
            name: "onOpenChange",
            type: "(open: boolean) => void",
            description: "Callback fired when the open state changes.",
          },
          {
            name: "children",
            type: "React.ReactNode",
            description: "Dialog content (typically DialogContent with nested components).",
          },
          {
            name: "defaultOpen",
            type: "boolean",
            description: "Uncontrolled initial open state.",
          },
        ],
      }}
    />
  );
}

